export const toStartCase = (text: string | null | undefined) => {
  return text ? text.charAt(0).toUpperCase() + text.slice(1).toLowerCase() : '';
};
